import axios from 'axios';
import { HTTPService, LocaleService } from '@sm360/widget-commons-core-services';

/**
 * Services talking to the Dealer location API for Dealer location list
 * @class DealerLocationListService
 */
class DealerLocationListService {
    fetchTradeInDealerList(provinceCode, orgId, latitude, longitude) {
        const AUTH_TOKEN = 'Basic c20zNjA6c20zNjA=';

        const langPrefix = LocaleService.getSimpleLocale();
        const endpoint = `/${langPrefix}/api/organization/${orgId}/organizationUnits/full?`;

        const queryParams =
            latitude && longitude
                ? `provinceCode=${provinceCode}&latitude=${latitude}&longitude=${longitude}&returnProximityList=true`
                : `provinceCode=${provinceCode}&returnProximityList=true`;
        const fullUrl = `${endpoint}${queryParams}`;

        return axios
            .get(`${fullUrl}`, {
                headers: {
                    authorization: AUTH_TOKEN,
                },
            })
            .then((response) => {
                if (!response || response.status === 204) {
                    return Promise.reject(HTTPService.formatRejectResponse('Dealer listing API error'));
                }
                return Promise.resolve(response.data);
            });
    }
}
export default new DealerLocationListService();
